export default __webpack_public_path__ + "static/media/MedidentLogo.d2585267.jpeg";